import { Component, OnInit, SecurityContext, ViewChild, ElementRef } from '@angular/core';

import { AlertsService } from 'src/modules/base/services/alerts.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { DialogConfig } from '../../dialog/dialog-config';
import { DomSanitizer } from '@angular/platform-browser';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { DialogRef } from '../../dialog/dialog-ref';
@Component({
    selector: 'html-viewer',
    styleUrls: ['./html-viewer.component.scss'],
    templateUrl: './html-viewer.component.html',
    standalone: false
})
export class HtmlViewerComponent implements OnInit {
  summary: boolean = false;
  config:any={};
  @ViewChild('htmlViewer') htmlViewer: ElementRef;
  constructor(
    private _route: ActivatedRoute,
    private alertService: AlertsService,
    private baseService: BaseService,
    private appService: AppService,
    private dialogConfig: DialogConfig,
    private domSanitizer: DomSanitizer,
    private loaderService: LoaderService,
    public dialogRef:DialogRef,
    private router: Router) {
  }

  ngOnInit() {
    this._route.params.subscribe(params => {
      if(params.identifier != undefined){
        this.setUpViewer(params.identifier);
      }else if(this.dialogConfig.data != undefined && this.dialogConfig.data.identifier != undefined){
        this.setUpViewer(this.dialogConfig.data.identifier);
      }else if(this.dialogConfig.data != undefined && this.dialogConfig.data.resource_name != undefined){
        this.setUpViewer(false,this.dialogConfig.data.resource_name);
      } else if (this?.dialogConfig?.data?.help_document_url != undefined){
        this.setUpViewer(false, false, this?.dialogConfig?.data?.help_document_url);
      }
    });
  }
  

  setUpViewer(identifier?,resource_name?,help_document_url?){
    try{
        let objRefer = {
          "application": "opsmgmt",
          "resource": "help_doc",
          "query_id": "GET_BY_RESOURCE_NAME",
        };
        if (resource_name) {
          objRefer["args"] = "fe_resource_name:" +resource_name
        } else if (identifier) {
          objRefer["args"] = "identifier:" + identifier
        } else if (help_document_url) {
          objRefer["args"] = "doc_url:" + help_document_url
          objRefer["query_id"] = "GET_DOCUMENT_BY_URL"
        }
        this.loaderService.showSpinner();
        this.baseService.getByDataSource(objRefer).subscribe((res) => {
          if (res.resource != null && res.resource.length > 0) {
            res = res.resource[0];
            this.htmlViewer.nativeElement.innerHTML  = this.domSanitizer.sanitize(SecurityContext.HTML,this.domSanitizer.bypassSecurityTrustHtml(res.final_html));
          }else{
            this.alertService.error("hpnf");
            console.error("Help not found : ",objRefer["args"]);
            this.dialogRef.close();
          }
          this.loaderService.hideSpinner();
        });
      }catch(e){
        this.alertService.error("hpnf");
        this.dialogRef.close();
    }
  }

  ngOnDestroy(){
   
  }
}
